import React from 'react';
import { cardSummaryStyle } from './styles';

const LifetimeTab = () => (
  <section>
    <div style={cardSummaryStyle}>
      <div className="ppm-stat-label">Lifetime Stats</div>
      <div style={{ marginTop: 8, fontSize: 18, fontWeight: 700, color: '#fff' }}>Feature coming soon</div>
      <p className="ppm-message" style={{ marginTop: 10 }}>
        We are preparing cross-season lifetime aggregation for this player.
      </p>
    </div>
  </section>
);

export default LifetimeTab;

